import { UseMutateFunction, useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApiSDK } from '../../contexts/apiSdkContext';
import { AppContext } from '../../contexts/app-context';

type TPlanDeleteHook = {
  isError: boolean;
  isLoading: boolean;
  mutate: UseMutateFunction<void, unknown, string, unknown>;
};

function useDeletePlan(): TPlanDeleteHook {
  const sdk = useApiSDK();
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { isError, isLoading, mutate } = useMutation({
    mutationFn: (id: string) => sdk.plans.delete(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries(['plans']);
      appContext?.crudAlert('delete', 'plan', 'm');
      navigate('/daily-plans');
    },
    onError: async (error: any) => {
      if (error) {
        const responseErrors = error.response.data.errors;
        responseErrors.forEach((err: { message: string; description: string }) => {
          appContext?.systemAlert('error', err.description);
        });
      }
    },
  });

  return { isError, isLoading, mutate };
}

export { useDeletePlan };
